var _circle, _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPotentialCustomerFinal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 170 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 75,
    stroke: "black",
    strokeWidth: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 117.057L55.9985 108.779C47.2599 99.7049 42.0141 86.1396 42.0141 69.7953C42.0141 47.8153 61.4652 30 85.4635 30C109.462 30 128.913 47.8153 128.913 69.7953C128.913 86.1399 123.667 99.7054 114.928 108.78L129.215 116.665C119.197 130.214 103.105 139 84.9611 139C66.9928 139 51.0369 130.383 41 117.057Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 167.5,
    width: 19,
    height: 15,
    fill: "black",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 183.5,
    width: 39,
    height: 21,
    rx: 5.5,
    fill: "black",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPotentialCustomerFinal);
export default __webpack_public_path__ + "static/media/potential-customer-final.3ebd7952eab55b9b84a07ca0f41ada80.svg";
export { ForwardRef as ReactComponent };